import { render, staticRenderFns } from "./InboxModals.vue?vue&type=template&id=500900b1&scoped=true"
import script from "./InboxModals.vue?vue&type=script&lang=js"
export * from "./InboxModals.vue?vue&type=script&lang=js"
import style0 from "./InboxModals.vue?vue&type=style&index=0&id=500900b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500900b1",
  null
  
)

export default component.exports